import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Globe } from 'lucide-react';

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n } = useTranslation();
  
  const toggleLanguage = () => {
    const newLang = i18n.language === 'de' ? 'en' : 'de';
    i18n.changeLanguage(newLang);
  };

  const currentLang = i18n.language === 'de' ? 'DE' : 'EN';
  const nextLang = i18n.language === 'de' ? 'EN' : 'DE';

  if (variant === "minimal") {
    return (
      <button
        onClick={toggleLanguage}
        className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-white transition-colors"
        data-testid="language-switcher"
      >
        <Globe className="h-4 w-4" />
        <span className="font-medium">{currentLang}</span>
      </button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 hover:bg-white/10"
      data-testid="language-switcher"
    >
      <Globe className="h-4 w-4" />
      <span className="font-medium">{currentLang}</span>
    </Button>
  );
}
